var _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 22,
    fill: "none",
    viewBox: "0 0 44 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 22,
    fill: "#50DE77",
    rx: 11
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.001,
    cy: 11,
    r: 9,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOn);
export default __webpack_public_path__ + "static/media/switch-on.1d58abf43639c8ae0d99fe3acbd16f69.svg";
export { ForwardRef as ReactComponent };